import {
  MsalProvider,
} from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Loader, ToastContainer } from "taltech-styleguide";
import { MobXProviderContext } from "mobx-react";
import { Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ContainerProvider } from "@hooks";
import { MainAppViewStore } from "configuration/MainAppViewStore";
import { IPublicClientApplication } from "@azure/msal-browser";
import 'primeicons/primeicons.css'
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-orange/theme.css";
import { ModalProvider } from "./components-common/modals";
import { application } from "./_runtime/bootstrap";
import { SessionContext } from "./_runtime/iam/session.context";
import { SessionProvider } from "./_runtime/iam/session.provider";
import { LoadingProvider } from "./components-common/_shared/loading/loading.context";
import { ActionProvider } from "./components-system/dispatcher/dispatcher.context";
application.start();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <MsalProvider instance={application.getService<IPublicClientApplication>("msal-instance")}>
      <MobXProviderContext.Provider value={{mainAppViewStore:application.viewStore}}>
        <SessionProvider>
          <LoadingProvider>
            <ModalProvider>
              <QueryClientProvider client={queryClient}>
                <ContainerProvider container={application.serviceProvider}>
                  <ActionProvider>
                      <App />
                      </ActionProvider>
                  <ToastContainer />
                </ContainerProvider>
              </QueryClientProvider>
            </ModalProvider>
          </LoadingProvider>
        </SessionProvider>
      </MobXProviderContext.Provider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
